import httpClient from "@/services/httpClient";
import {
    server
} from "@/services/constants";

export const getAllMASTERPT_PRIORITY = () => {
    return httpClient.get(server.MASTERPT_PRIORITY + `/getAll`);
};
export const getAllMASTERPT_PRIORITY_BYID = (id) => {
    return httpClient.get(server.MASTERPT_PRIORITY + `/pt/${id}`);
};
export const getAllMASTERPT_PRIORITY_BYIDTM = (id) => {
    return httpClient.get(server.MASTERPT_PRIORITY + `/tm/${id}`);
};



export const createMASTERPT_PRIORITY = (data) => {
    return httpClient.post(server.MASTERPT_PRIORITY, data);
};

export const updateMASTERPTPRIORITY = (id, data) => {
    return httpClient.put(server.MASTERPT_PRIORITY + `/${id}`, data);
};

export const deleteMASTERPTPRIORITY = (id) => {
    return httpClient.delete(server.MASTERPT_PRIORITY + `/${id}`);
};